import { GetTagsUseCase, TAG_REPOSITORY, GET_TAGS_USE_CASE } from '@module/form';
export var tagUseCaseProviders = [{
  provide: GET_TAGS_USE_CASE,
  useFactory: function useFactory(tagRepository) {
    return new GetTagsUseCase(tagRepository);
  },
  inject: [TAG_REPOSITORY]
}];